import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import antd_en_US from './lang/antd_en_US'
import { ConfigProvider } from 'antd';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <ConfigProvider locale={antd_en_US}>
    <App />
  </ConfigProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
